module.exports = __webpack_public_path__ + "media/sms.b4b2a643.svg";


//////////////////
// WEBPACK FOOTER
// ./src/templates/coffee/assets/sms.svg
// module id = ./src/templates/coffee/assets/sms.svg
// module chunks = 0